module.exports = __webpack_public_path__ + "img/0bcf0a6.jpg";